import { CoherencePanel } from '@coherence-design-system/controls';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { DefaultButton } from '@micro-frontend-react/employee-experience/lib/Buttons/DefaultButton';
import { getFeature } from '@micro-frontend-react/employee-experience/lib/UsageTelemetryHelper';
import { Spinner } from 'office-ui-fabric-react';
import * as React from 'react';
import { PageContainer } from '../../Home.styled';
import { ILetterTemplate } from '../../../models/ILetterTemplate';
import { useLetterMetadata } from '../../../redux/hooks/useLetterMetadata';
import * as styled from './MailedGenerationPanel.styled';
import { MetadataContext } from '../../../shared/MetadataContext';

export interface ISuccessfulGenerationPanelProps {
  selectedLetter: ILetterTemplate;
}

export function MailedGenerationPanel(props: ISuccessfulGenerationPanelProps): React.ReactElement {
  const { selectedLetter } = props;
  const { telemetryClient } = React.useContext(
    Context as React.Context<IEmployeeExperienceContext>
  );
  const feature = getFeature('EVL', 'MailedGenerationPanel');
  const [
    letterMetadata,
    letterPdf,
    hasError,
    isLoading,
    errorMessage,
    isLoadingLetterGeneration,
    isLoadingLetterSubmission,
    hasErrorLetterGeneration,
    hasErrorLetterSubmission,
    errorMessageLetterGeneration,
    errorMessageLetterSubmission,
    crmActivityId,
  ] = useLetterMetadata(feature, selectedLetter);

  return (
    <>
      <MetadataContext.Consumer>
        {(context) => (
          <CoherencePanel
            isOpen={context.showMailedGenerationPanel}
            //onDismiss={toggle}
            customWidth={`900px`}
            isLightDismiss={true}
            titleText={`${selectedLetter?.name}`}
            closeButtonAriaLabel="Close panel"
            hasCloseButton={false}
            overlayProps={{
              isDarkThemed: true,
            }}
            telemetryHook={telemetryClient}
          >
            <PageContainer>
              <styled.Separator />
              {isLoadingLetterSubmission && !hasErrorLetterSubmission && (
                <Spinner label="Requesting letter... Please do not close the browser." />
              )}
              <styled.SuccessGenerationContainer>
                {!isLoadingLetterSubmission && (
                  <>
                    {hasErrorLetterSubmission && (
                      <styled.SuccessImage src={`./assets/NotFoundLogo.png`} role="presentation" />
                    )}
                    {!hasErrorLetterSubmission && (
                      <styled.SuccessImage
                        src={`./assets/emailedLetterGeneration.png`}
                        role="presentation"
                      />
                    )}
                    <styled.BreakFlexDiv />
                    <styled.SuccessMessage>
                      {hasErrorLetterSubmission
                        ? 'Oops! Something went wrong while requesting the letter.'
                        : 'HR will notify you to collect the letter shortly.'}
                    </styled.SuccessMessage>
                    <styled.BreakFlexDiv />
                    <DefaultButton
                      text={hasErrorLetterSubmission ? 'Try again' : 'Start a new one'}
                      title={hasErrorLetterSubmission ? 'Try again' : 'Start a new one'}
                      usageEvent={{
                        feature: 'EVL',
                        subFeature: hasErrorLetterSubmission
                          ? 'MailedGenerationPanel.TryAgainButton'
                          : 'MailedGenerationPanel.StartNewButton',
                      }}
                      style={{ marginTop: 20 }}
                      onClick={() => {
                        context.clearSelectedLetter();
                        context.toggleMailedGenerationPanel(false);
                      }}
                    />
                  </>
                )}
              </styled.SuccessGenerationContainer>
            </PageContainer>
          </CoherencePanel>
        )}
      </MetadataContext.Consumer>
    </>
  );
}
